(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      this.isTransparentHeader = this.classList.contains('header-wrapper--transparent');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      if (this.isIOS) {
        document.documentElement.classList.add('ios-sticky-header');
        this.headerBounds = { top: 0, bottom: this.header.offsetHeight };
        if (this.isTransparentHeader) {
          this.header.classList.remove('shopify-section-header-hidden', 'animate');
          this.header.classList.add('shopify-section-header-sticky');
        }
      } else {
        this.createObserver();
      }
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.isIOS && this.headerBounds) {
        this.headerBounds.bottom = this.header.offsetHeight;
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      const searchModal = this.searchModal || this.querySelector('details-modal');
      if (searchModal && typeof searchModal.isOpen === 'function' && searchModal.isOpen()) return;
      if (document.querySelector('.header-buttons-drawer[open]:not(.header-buttons-drawer--closing)')) return;
      if (!this.headerBounds || this.headerBounds.bottom == null) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.preventHide) return;
      if (document.querySelector('.header-buttons-drawer[open]:not(.header-buttons-drawer--closing)')) return;
      if (this.headerIsAlwaysSticky) return;
      if (this.isTransparentHeader) {
        this.classList.add('header-wrapper--scroll-hidden');
        this.closeMenuDisclosure();
        this.closeSearchModal();
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.isTransparentHeader) {
        this.classList.remove('header-wrapper--scroll-hidden');
        return;
      }
      this.header.classList.add('shopify-section-header-sticky');
      if (!this.isIOS) this.header.classList.add('animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.preventHide) return;
      if (document.querySelector('.header-buttons-drawer[open]:not(.header-buttons-drawer--closing)')) return;
      if (this.headerIsAlwaysSticky) return;
      if (this.isTransparentHeader) {
        this.classList.remove('header-wrapper--scroll-hidden');
        return;
      }
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Transparent Header Scroll Handler
  class TransparentHeader {
    constructor() {
      this.headerWrapper = document.querySelector('.header-wrapper--transparent');
      if (!this.headerWrapper) return;

      this.scrollThreshold = 50; // Pixels to scroll before header becomes solid
      this.isScrolled = false;

      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.handleScroll(); // Check initial state
    }

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldBeScrolled = scrollTop > this.scrollThreshold;
      
      // Keep scrolled state if mega menu or drawer is open
      const hasMegaMenuOpen = this.headerWrapper.dataset.megaMenuOpen === 'true';
      const hasDrawerOpen = this.headerWrapper.dataset.drawerOpen === 'true';
      
      if (shouldBeScrolled !== this.isScrolled) {
        this.isScrolled = shouldBeScrolled;
        if (this.isScrolled) {
          this.headerWrapper.classList.add('header-wrapper--scrolled');
        } else {
          // Only remove scrolled class if neither mega menu nor drawer is open
          if (!hasMegaMenuOpen && !hasDrawerOpen) {
            this.headerWrapper.classList.remove('header-wrapper--scrolled');
          }
        }
      } else if ((hasMegaMenuOpen || hasDrawerOpen) && !this.isScrolled) {
        // If drawer/mega menu is open but we're at top, ensure scrolled class is added
        this.headerWrapper.classList.add('header-wrapper--scrolled');
      }
    }
  }

  // Initialize transparent header on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new TransparentHeader();
    });
  } else {
    new TransparentHeader();
  }

  } catch(e) { console.error(e); }
})();
})();
